import { render, staticRenderFns } from "./super_console.vue?vue&type=template&id=5b193ef0&scoped=true"
import script from "./super_console.vue?vue&type=script&lang=js"
export * from "./super_console.vue?vue&type=script&lang=js"
import style0 from "./super_console.vue?vue&type=style&index=0&id=5b193ef0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b193ef0",
  null
  
)

export default component.exports